import DynamicView from './src/dynamicFormView.vue';

/* istanbul ignore next */
DynamicView.install = function(Vue) {
    Vue.component(DynamicView.name, DynamicView);
};

export default DynamicView;